import React, { useState, useEffect } from 'react';
import Overlay from '@RHEnvironmental/pattern-library/dist/js/components/Overlay';
import InlineButtonPanel from '@RHEnvironmental/pattern-library/dist/js/components/InlineButtonPanel';
import Button from '@RHEnvironmental/pattern-library/dist/js/components/Button';
import { getClassNames } from '@RHEnvironmental/pattern-library/dist/js/services/stylingUtils';
import LoadingIndicator from '@RHEnvironmental/pattern-library/dist/js/components/LoadingIndicator';
import BodyText from '../BodyText';

/**
 * @deprecated Use ConfirmationModal
 */
const ConfirmModal = ({
    className = undefined,
    theme,
    show,
    onConfirm,
    onCancel,
    messageBody = 'Are you sure?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    title = 'hello',
    showLoading = false,
}) => {
    const [clicked, setClicked] = useState(false);
    const classNames = getClassNames(className, {
        'rhe-overlay': true,
        'confirm-modal--warning': theme === 'warning',
    });

    useEffect(() => {
        setClicked(false);
    }, [show]);

    return (
        <>
            {show && (
                <Overlay
                    isOpen
                    className={classNames}
                    autoHeight="true"
                    onClose={() => onCancel()}
                    onRequestClose={() => onCancel()}
                    title={title}
                >
                    <div>
                        <BodyText>{messageBody}</BodyText>
                        <InlineButtonPanel>
                            <Button
                                disabled={clicked}
                                className="button--white"
                                onClick={() => onCancel()}
                            >
                                {cancelText}
                            </Button>
                            <Button
                                className="ml-2"
                                disabled={clicked}
                                theme={theme}
                                onClick={() => {
                                    setClicked(true);
                                    onConfirm();
                                }}
                            >
                                {confirmText}
                            </Button>
                            <LoadingIndicator show={showLoading} />
                        </InlineButtonPanel>
                    </div>
                </Overlay>
            )}
        </>
    );
};

export default ConfirmModal;
